class aBtnSizeguide extends HTMLButtonElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener('click', () => {
            this.toggleSizeGuidePanel();
        });
    }

    toggleSizeGuidePanel() {
        const url = this.dataset.content;
        const sidebar = document.getElementById('o-sidebar-sizeguide');
        const panelContent = sidebar.querySelector('.content');

        if (url) {
            fetch(url, {
                method: 'GET'
            })
            .then((response) => {
                return response.text();
            })
            .then((responseData) => {
                panelContent.innerHTML = responseData;
            });
        }
    }
}

customElements.define('a-btn-sizeguide', aBtnSizeguide, {
    extends: 'button'
});
